import { combineReducers } from "@reduxjs/toolkit";
import { leaveReducer } from "./leave";

export const meReducer = combineReducers({
  leave: leaveReducer,
});
